import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export const Properties = () => {
  useEffect(() => {
    document.title = 'PlanOmatic - Properties';

    return () => {
      document.title = 'PlanOmatic';
    };
  }, []);
  return <Outlet />;
};
